import Model from '@/models/Model.js';

export default class Satisfier extends Model {
    static entity = 'satisfiers';

    static fields() {
        return {
            id: this.uid(null),
            time_period_id: this.attr(null),
            activity_id: this.attr(null),
            action: this.string(''),
            percent_of_time: this.number(null),
            requires_confirmation: this.boolean(false),
            order: this.number(null),

            ...super.fields(),

            time_period: this.belongsTo('time_periods', 'time_period_id'),
            activity: this.belongsTo('activities', 'activity_id'),
        };
    }
}
